module.exports = __webpack_public_path__ + "static/media/arrow-left.207a7aa5.svg";